define('views/content/customer_managers',['require','views/base/list_page_view','views/components/customer_manager/customer_managers','collections/customer_managers','text!templates/content/customer_managers.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var CustomerManagersView = require('views/components/customer_manager/customer_managers');
    var CustomerManagersCollection = require('collections/customer_managers');

    var temp = require("text!templates/content/customer_managers.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'customer-managers-page',
        titleKey: 'customer_managers',

        setCollection: function () {
            this.collection = new CustomerManagersCollection();
        },

        onRender: function() {
            this.ListContainer.show(new CustomerManagersView({
                collection: this.collection
            }));
        }

    });
});
